module.exports = __webpack_public_path__ + "media/Trumpet-sound.cb499a0b.mp3";